<template>
  <modal
    name="magazine-modal"
    :resizable="true"
    :height="'auto'"
    :width="'100%'"
    :scrollable="true"
  >
    <!-- Toast powodzenia -->
    <div v-if="showToast" class="success-toast">
      ✓ Przedmiot został zaktualizowany!
    </div>

    <!-- Nagłówek modalu -->
    <div class="modal-header-custom">
      <div class="header-content">
        <h3 class="modal-title">📦 {{ item.title }}</h3>
        <p class="modal-subtitle">Edycja przedmiotu magazynowego</p>
      </div>
      <button class="btn-close-modal" @click="$emit('closeModal')">
        ✕
      </button>
    </div>

    <!-- Zawartość modalu -->
    <div class="modal-content-custom">
      <!-- Sekcja podstawowych informacji -->
      <div class="form-section">
        <h5 class="section-title">
          <span class="section-icon">📦</span>
          Informacje podstawowe
        </h5>

        <div class="form-group">
          <label class="form-label">Nazwa przedmiotu *</label>
          <input
            v-model="item.title"
            type="text"
            class="form-input"
            placeholder="np. Śruby M8, Klej montażowy, Pianka PU..."
          />
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Ilość (sztuk) *</label>
            <input
              v-model="item.quantity"
              type="number"
              min="0"
              class="form-input"
              placeholder="np. 100"
            />
            <div v-if="item.quantity && parseInt(item.quantity) <= 10" class="warning-message">
              ⚠️ Niska ilość - niski stan magazynowy
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">Ostatnia edycja</label>
            <div class="date-info">
              <span class="date-icon">📅</span>
              {{ itemDataToLocal }}
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">Uwagi / Opis</label>
          <vue-editor
            v-model="item.notice"
            class="editor"
          ></vue-editor>
        </div>
      </div>
    </div>

    <!-- Fixed footer -->
    <div class="modal-footer-custom">
      <div class="footer-left"></div>
      <div class="footer-center">
        <button class="btn-submit" @click="updateItem(item)">
          <span class="submit-icon">✓</span>
          Zapisz zmiany
        </button>
        <button class="btn-cancel" @click="$emit('closeModal')">
          Anuluj
        </button>
      </div>
      <div class="footer-right">
        <button class="btn-delete" @click="deleteItem(item)">
          <span class="delete-icon">🗑️</span>
          Usuń przedmiot
        </button>
      </div>
    </div>
  </modal>
</template>
<script>
import { mapState } from "vuex";
import { VueEditor } from "vue2-editor";

export default {
  props: ["item"],
  label: "",

  data() {
    return {
      imageUrl: "",
      consolelog: "test",
      showToast: false,
    };
  },
  components: {
    VueEditor
  },
  computed: {
    ...mapState(["userProfile", "magazineItemUpdated"]),
    itemDataToLocal() {
      if (this.item.lastEdit) {
        return new Date(this.item.lastEdit.seconds * 1000).toLocaleDateString();
      } else {
        return "Nie był edytowany";
      }
    },
  },

  // created() {
  //   var scripts = ["https://smtpjs.com/v3/smtp.js"];
  //   scripts.forEach((script) => {
  //     let tag = document.createElement("script");
  //     tag.setAttribute("src", script);
  //     document.head.appendChild(tag);
  //   });
  // },

  methods: {
    // send(payment) {
    //   Email.send({
    //     SecureToken: "edd158ac-b4c0-46b9-8986-d78583d5ce84",
    //     // Host: "serwer1984787.home.pl",
    //     // Username: "no-reply-klimbud@2qbs.pl",
    //     // Password: "y9tTLZp_K",
    //     To: payment.contractor.email,
    //     Cc: "biuro@klim-bud.pl",
    //     From: "no-reply-klimbud@2qbs.pl",
    //     Subject: "Przypomnienie o terminie płatności faktury " + payment.invoiceNumber,
    //     Body:
    //       "<h2> Przypominamy o nieopłaconej fakturze nr. " +
    //       payment.invoiceNumber +
    //       " </h2>" +
    //       "<div>" +
    //       "Kwota: " +
    //       payment.price +
    //       "<br/>" +
    //       "Data płatności: " +
    //       payment.date +
    //       "<br>" +
    //       "<br>" +
    //       "<small>Wiadomość została wygenerowana automatycznie, prosimy na nią nie odpowiadać.</small>" +
    //       "</div>" +
    //       "<br>" +
    //       "<hr>" +
    //       "<div>" +
    //       "<br>" +
    //       "<br>" +
    //       "<img src='https://klim-bud.pl/wp-content/uploads/2020/07/LOGO_KLIM-BUD.png'>" +
    //       "<br>" +
    //       "<br>" +
    //       "F.H.U Klim-Bud" +
    //       "<br>" +
    //       "Wąska 4" +
    //       "<br>" +
    //       "43-520 Chybie" +
    //       "<br>" +
    //       "tel. 504 041 946" +
    //       "<br>" +
    //       "<a href='mailto:biuro@klim-bud.pl'>biuro@klim-bud.pl</a> " +
    //       "<br>" +
    //       "<a href='https://klim-bud.pl' target='_blank'>www.klim-bud.pl</a>",
    //   }).then(() => alert("Przypomnienie zostało wysłane"));
    // },

    updateItem(item) {
      if (!item.title || !item.quantity) {
        alert("Wypełnij wszystkie wymagane pola");
        return;
      }

      this.$store
        .dispatch("updateMagazineItem", {
          id: item.id,
          notice: item.notice,
          quantity: parseInt(item.quantity),
          title: item.title,
        })
        .then(() => {
          this.showSuccessToast();
          setTimeout(() => {
            this.$emit("closeModal");
          }, 1500);
        })
        .catch((err) => {
          alert("Błąd podczas aktualizacji: " + err);
        });
    },

    showSuccessToast() {
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
      }, 3000);
    },

    deleteItem(item) {
      if (confirm("Czy jesteś pewien ze chcesz usunąć element?")) {
        this.$store.dispatch("deleteMagazineItem", {
          id: item.id,
        });

        setTimeout(() => {
          this.$emit("closeModal");
        }, 200);
        console.log("payment Deleted.");
      }
    },
  },
};
</script>

<style scoped>
/* --- Nagłówek modalu --- */
.modal-header-custom {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 30px 40px;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.3);
}

.header-content {
  flex: 1;
}

.modal-title {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: white;
}

.modal-subtitle {
  margin: 6px 0 0 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 400;
}

.btn-close-modal {
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
}

.btn-close-modal:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: rotate(90deg);
}

/* --- Zawartość modalu --- */
.modal-content-custom {
  padding: 40px;
  margin-bottom: 100px;
  background: #f8f9fa;
}

/* --- Sekcje formularza --- */
.form-section {
  background: white;
  border-radius: 16px;
  padding: 30px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.section-title {
  font-size: 20px;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 25px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-icon {
  font-size: 24px;
}

/* --- Pola formularza --- */
.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #4a5568;
  margin-bottom: 8px;
}

.form-input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 15px;
  color: #2d3748;
  transition: all 0.2s ease;
  background: white;
}

.form-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-input::placeholder {
  color: #a0aec0;
}

/* --- Data info --- */
.date-info {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: #f7fafc;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 15px;
  color: #2d3748;
  font-weight: 500;
}

.date-icon {
  font-size: 18px;
}

/* --- Editor --- */
.editor {
  border-radius: 10px;
  overflow: hidden;
}

.editor >>> .ql-toolbar {
  border: 2px solid #e2e8f0;
  border-bottom: none;
  border-radius: 10px 10px 0 0;
  background: #f7fafc;
}

.editor >>> .ql-container {
  border: 2px solid #e2e8f0;
  border-radius: 0 0 10px 10px;
  font-size: 15px;
  min-height: 200px;
}

.editor >>> .ql-editor:focus {
  border-color: #667eea;
}

/* --- Komunikaty --- */
.warning-message {
  color: #ed8936;
  font-size: 13px;
  margin-top: 6px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* --- Fixed footer --- */
.modal-footer-custom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  padding: 20px 40px;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1000;
}

.footer-left {
  flex: 1;
}

.footer-center {
  display: flex;
  gap: 15px;
  align-items: center;
}

.footer-right {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.btn-submit {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 14px 40px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.btn-submit:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(102, 126, 234, 0.5);
}

.submit-icon {
  font-size: 18px;
  font-weight: bold;
}

.btn-cancel {
  background: transparent;
  color: #718096;
  border: none;
  padding: 14px 24px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-cancel:hover {
  color: #2d3748;
  background: #f7fafc;
}

.btn-delete {
  background: #fff5f5;
  color: #c53030;
  border: 2px solid #fc8181;
  padding: 14px 24px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-delete:hover {
  background: #c53030;
  color: white;
  border-color: #c53030;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(197, 48, 48, 0.3);
}

.delete-icon {
  font-size: 16px;
}

/* --- Toast powodzenia --- */
.success-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
  color: white;
  padding: 16px 24px;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(72, 187, 120, 0.4);
  font-size: 15px;
  font-weight: 600;
  z-index: 1000;
  animation: slideIn 0.3s ease;
  display: flex;
  align-items: center;
  gap: 10px;
}

@keyframes slideIn {
  from {
    transform: translateX(400px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* --- Responsywność --- */
@media (max-width: 768px) {
  .modal-header-custom {
    padding: 20px 25px;
  }

  .modal-title {
    font-size: 22px;
  }

  .modal-content-custom {
    padding: 25px 20px;
  }

  .form-section {
    padding: 20px;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .modal-footer-custom {
    flex-direction: column;
    padding: 15px 20px;
    gap: 10px;
  }

  .footer-left,
  .footer-right {
    display: none;
  }

  .footer-center {
    flex-direction: column;
    width: 100%;
  }

  .btn-submit,
  .btn-cancel,
  .btn-delete {
    width: 100%;
    justify-content: center;
  }

  .footer-right {
    display: flex;
    width: 100%;
  }
}
</style>
